/*
 * AeroPress custom sections: tabs, variant swatches, and modular video.
 */
(function () {
  'use strict';

  function money(cents) {
    if (window.AeroPressCart && window.AeroPressCart.formatMoney) {
      return window.AeroPressCart.formatMoney(cents);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  /* ------------------------------------------------------------------ Tabs */
  function activateTab(root, index) {
    var tabs = root.querySelectorAll('.ap-tabs__tab[data-tab]');
    tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-tab') === String(index);
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-tab-panel') === String(index);
      panel.classList.toggle('is-active', active);
      if (active) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
    });

    root.querySelectorAll('[data-tab-media]').forEach(function (media) {
      var active = media.getAttribute('data-tab-media') === String(index);
      media.classList.toggle('is-active', active);
    });
  }

  function initTabs(root) {
    root.addEventListener('click', function (event) {
      var tab = event.target.closest('.ap-tabs__tab[data-tab]');
      if (!tab || !root.contains(tab)) return;
      activateTab(root, tab.getAttribute('data-tab'));
    });
  }

  /* -------------------------------------------------------------- Swatches */
  function initSwatches(scope) {
    scope.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-swatch]');
      if (!swatch) return;
      var card = swatch.closest('[data-ap-card]');
      if (!card) return;

      var group = swatch.closest('.ap-card__swatches');
      if (group) {
        group.querySelectorAll('[data-swatch]').forEach(function (s) {
          s.classList.remove('is-active');
          s.setAttribute('aria-checked', 'false');
        });
      }
      swatch.classList.add('is-active');
      swatch.setAttribute('aria-checked', 'true');

      var variantId = swatch.getAttribute('data-variant-id');
      var available = swatch.getAttribute('data-variant-available') === 'true';
      var price = swatch.getAttribute('data-price');
      var comparePrice = swatch.getAttribute('data-compare-price');
      var image = swatch.getAttribute('data-image');
      var value = swatch.getAttribute('data-value');

      card.setAttribute('data-variant-id', variantId);

      // Image swap
      if (image) {
        var img = card.querySelector('.ap-card__img, .ap-showcase__img, [data-showcase-image] img');
        if (img) {
          img.setAttribute('src', image);
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
      }

      // Price
      var current = card.querySelector('[data-price-current]');
      if (current && price != null) current.textContent = money(price);
      var compare = card.querySelector('[data-price-compare]');
      if (compare) {
        if (comparePrice && Number(comparePrice) > Number(price)) {
          compare.textContent = money(comparePrice);
          compare.removeAttribute('hidden');
        } else {
          compare.textContent = '';
          compare.setAttribute('hidden', '');
        }
      }

      // Selected colour label (showcase)
      var valueLabel = card.querySelector('[data-swatch-value]');
      if (valueLabel && value) valueLabel.textContent = value;

      // Add-to-cart button
      var addBtn = card.querySelector('[data-ap-add]');
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', variantId);
        addBtn.disabled = !available;
        var lbl = addBtn.querySelector('[data-atc-label]');
        if (lbl) lbl.textContent = available ? 'Add To Cart' : 'Sold Out';
        var priceText = addBtn.querySelector('[data-atc-price-text]');
        if (priceText) priceText.textContent = available && price != null ? '- ' + money(price) : '';
      }
    });
  }

  /* ----------------------------------------------------------------- Video */
  function injectEmbed(el) {
    var template = el.querySelector('template[data-video-embed]');
    if (!template || el.dataset.embedInjected === 'true') return;
    var poster = el.querySelector('[data-video-poster]');
    el.insertBefore(template.content.cloneNode(true), poster || null);
    el.dataset.embedInjected = 'true';
    if (poster) poster.setAttribute('hidden', '');
  }

  function safePlay(video) {
    if (!video) return;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Click-to-start (with sound): reveal the native video / inject the embed,
  // unmute, show controls, play, and hide the poster. Triggered by a tap
  // anywhere on the poster (not just the small play button).
  function playVideo(el) {
    var template = el.querySelector('template[data-video-embed]');
    var poster = el.querySelector('[data-video-poster]');
    var native = el.querySelector('video.ap-video__media');

    if (template) {
      injectEmbed(el);
      return;
    }
    if (native) {
      native.removeAttribute('hidden');
      native.muted = false;
      native.controls = true;
      safePlay(native);
      if (poster) poster.setAttribute('hidden', '');
    }
  }

  // Autoplay-in-view (muted): play when the section scrolls into view, pause when
  // it leaves. Play is (re)issued on each entry so it survives a muted autoplay the
  // browser declines before the video is on screen.
  function initAutoplayInView(el) {
    var native = el.querySelector('video.ap-video__media');
    var template = el.querySelector('template[data-video-embed]');
    var poster = el.querySelector('[data-video-poster]');

    function enter() {
      if (template) { injectEmbed(el); return; }
      if (native) {
        // Keep the viewer's sound choice: once unmuted, re-entry must not re-mute.
        native.muted = el.dataset.userUnmuted !== '1';
        native.removeAttribute('hidden');
        if (poster) poster.setAttribute('hidden', '');
        safePlay(native);
      }
    }
    function leave() { if (native && !native.paused) { try { native.pause(); } catch (e) {} } }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) enter(); else leave();
        });
      }, { threshold: 0.35 });
      io.observe(el);
    } else {
      enter();
    }

    // Unmute toggle (autoplay mode only). The button is a SIBLING of <ap-video>
    // (rendered outside the overflow:hidden box), so look in the parent wrapper.
    var scope = el.parentNode || el;
    var unmute = scope.querySelector('[data-video-unmute]');
    if (unmute && native) {
      unmute.addEventListener('click', function () {
        var nowUnmuted = native.muted; // about to flip
        native.muted = !native.muted;
        if (!native.muted) { el.dataset.userUnmuted = '1'; native.volume = 1; safePlay(native); }
        else { delete el.dataset.userUnmuted; }
        unmute.setAttribute('aria-pressed', String(nowUnmuted));
      });
    }
  }

  function initVideo(el) {
    var mode = el.dataset.mode || 'background';
    var poster = el.querySelector('[data-video-poster]');
    var playBtn = el.querySelector('[data-video-play]');

    if (mode === 'background' || mode === 'autoplay') {
      initAutoplayInView(el);
    } else {
      // Click / tap to start — the whole poster is the target, with the play
      // button as the visual affordance. Works on mobile where the button may
      // be hidden.
      var start = function (e) { if (e && e.preventDefault) e.preventDefault(); playVideo(el); };
      if (poster) { poster.addEventListener('click', start); poster.style.cursor = 'pointer'; }
      if (playBtn) playBtn.addEventListener('click', function (e) { if (e && e.stopPropagation) e.stopPropagation(); start(e); });
    }
  }

  /* ------------------------------------------------------------- Newsletter */
  // Client-side Klaviyo list subscription (public key + list id from the
  // section settings). On success, swap the fields for the success message.
  function initNewsletter(form) {
    var key = form.getAttribute('data-klaviyo-key');
    var listId = form.getAttribute('data-klaviyo-list');
    if (!key || !listId) return;
    var fields = form.querySelector('[data-newsletter-fields]');
    var success = form.querySelector('[data-newsletter-success]');
    var error = form.querySelector('[data-newsletter-error]');
    var button = form.querySelector('button[type="submit"]');

    function fail(message) {
      if (error) { error.textContent = message; error.removeAttribute('hidden'); }
      if (button) button.disabled = false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = input ? input.value.trim() : '';
      if (!email) { fail('Please enter a valid email.'); return; }
      if (error) error.setAttribute('hidden', '');
      if (button) button.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).then(function (res) {
        if (res.ok || res.status === 202) {
          if (fields) fields.setAttribute('hidden', '');
          if (success) success.removeAttribute('hidden');
        } else {
          fail('Something went wrong. Please try again.');
        }
      }).catch(function () {
        fail('Something went wrong. Please try again.');
      });
    });
  }

  /* -------------------------------------------------------------- Carousel */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    function step() {
      var cell = track.querySelector('.ap-grid__cell');
      return cell ? cell.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* -------------------------------------------------- Comparison carousel */
  function initCompare(root) {
    var wrap = root.querySelector('.ap-compare__slidewrap');
    var track = root.querySelector('[data-compare-track]');
    // Dots live as a sibling of [data-compare] inside .ap-compare, so search the section root.
    var dotScope = root.closest('.ap-compare') || root.parentNode || root;
    var dots = dotScope.querySelector('[data-compare-dots]');
    if (!wrap || !track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.ap-compare__slide'));
    if (slides.length === 0) return;
    var index = 0;
    function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
    if (dots) {
      dots.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        if (i === 0) b.className = 'is-active';
        b.setAttribute('aria-label', 'Show comparison column ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
      });
    }
    function apply() {
      if (isMobile()) {
        track.style.transform = 'translateX(' + (-index * wrap.clientWidth) + 'px)';
      } else {
        track.style.transform = 'none';
      }
      if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    function go(i) { index = Math.max(0, Math.min(i, slides.length - 1)); apply(); }
    apply();
    window.addEventListener('resize', apply);
    var x0 = null;
    wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ------------------------------------------------- Steps (click to swap) */
  function initSteps(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.ap-steps__item'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-step-select]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-step-media]'));
    if (!buttons.length || !panels.length) return;

    function playPanel(panel) {
      if (!panel) return;
      var native = panel.querySelector('video.ap-video__media');
      if (native) {
        native.removeAttribute('hidden');
        var p = native.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    function pausePanel(panel) {
      var native = panel.querySelector('video.ap-video__media');
      if (native && native.pause) { try { native.pause(); } catch (e) {} }
    }

    function activate(index) {
      index = String(index);
      items.forEach(function (li) {
        var btn = li.querySelector('[data-step-select]');
        var on = btn && btn.getAttribute('data-step-select') === index;
        li.classList.toggle('is-active', !!on);
        if (btn) btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-step-media') === index;
        panel.classList.toggle('is-active', on);
        if (on) { panel.removeAttribute('hidden'); playPanel(panel); }
        else { panel.setAttribute('hidden', ''); pausePanel(panel); }
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn.getAttribute('data-step-select')); });
    });
    // Ensure the first panel's video is playing on load.
    var first = panels.filter(function (p) { return p.classList.contains('is-active'); })[0] || panels[0];
    playPanel(first);
  }

  /* ----------------------------------------- Feature carousel (mobile) */
  function initFeatures(root) {
    var track = root.querySelector('.ap-features__grid');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.ap-features__col'));
    if (slides.length < 2) return;
    var dotsWrap = root.querySelector('[data-features-dots]');
    var prev = root.querySelector('[data-features-prev]');
    var next = root.querySelector('[data-features-next]');

    function slideWidth() {
      return (slides[0] && slides[0].getBoundingClientRect().width) || track.clientWidth || 1;
    }
    function currentIndex() {
      return Math.round(track.scrollLeft / slideWidth());
    }
    function scrollToIndex(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
    }
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        if (i === 0) b.className = 'is-active';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { scrollToIndex(i); });
        dotsWrap.appendChild(b);
      });
    }
    function update() {
      var i = currentIndex();
      if (dotsWrap) Array.prototype.forEach.call(dotsWrap.children, function (d, di) { d.classList.toggle('is-active', di === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ------------------------------------------------- Hero scroll hint */
  function initHeroScroll(btn) {
    // Prevent the browser from auto-scrolling the focused button into view on tap;
    // recompute the scroll target live each time.
    btn.addEventListener('pointerdown', function (e) { if (e.cancelable) e.preventDefault(); });
    btn.addEventListener('click', function (e) {
      if (e && e.preventDefault) e.preventDefault();
      var hero = btn.closest('.ap-hero');
      var wrap = hero ? (hero.closest('.shopify-section') || hero) : null;
      var next = wrap && wrap.nextElementSibling;
      var top;
      if (next) {
        top = next.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      } else {
        top = (window.pageYOffset || 0) + Math.round(window.innerHeight * 0.9);
      }
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: 'smooth' });
    });
  }

  /* ------------------------------------------------------------------ Boot */
  // Init each matched element independently; a failure in one never halts the
  // rest (so a broken section can't take down video playback, etc.).
  function each(context, selector, readyKey, fn) {
    (context || document).querySelectorAll(selector).forEach(function (el) {
      if (el.dataset[readyKey] === 'true') return;
      el.dataset[readyKey] = 'true';
      try { fn(el); } catch (e) { if (window.console) console.error('[ap-sections]', selector, e); }
    });
  }

  function boot(context) {
    each(context, '[data-ap-scroll]', 'apScrollReady', initHeroScroll);
    each(context, '[data-ap-tabs]', 'apTabsReady', function (root) { initTabs(root); initSwatches(root); });
    // Swatches can also live outside a tabs container (single product cards).
    each(context, '[data-ap-card]', 'apCardReady', function (card) {
      if (card.closest('[data-ap-tabs]')) return; // handled above
      initSwatches(card);
    });
    each(context, '[data-ap-carousel]', 'apCarouselReady', initCarousel);
    each(context, '[data-ap-steps]', 'apStepsReady', initSteps);
    each(context, '[data-features]', 'apFeaturesReady', initFeatures);
    each(context, '[data-compare]', 'apCompareReady', initCompare);
    each(context, 'ap-video', 'apVideoReady', initVideo);
    each(context, '[data-ap-newsletter]', 'apNewsletterReady', initNewsletter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
